import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { StringUtils } from '../system-utils/utils/StringUtils';
import { LanguageServices } from './LanguageServices';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {

  constructor(private translate:LanguageServices) { }
  private _darkTheme = new Subject<boolean>();
  isDarkTheme:Observable<Boolean> = this._darkTheme.asObservable();

  // estado corrente em memória — o localStorage é só persistência entre
  // sessões; ler direto dele deixava os grids defasados na troca ao vivo
  private _theme:boolean = localStorage.getItem('darkTheme')==null? false : StringUtils.stringToBoolean(localStorage.getItem('darkTheme'));

  setDarkTheme(isDarkTheme: boolean): void {
    this._theme = isDarkTheme;
    localStorage.setItem('darkTheme', String(isDarkTheme));
    this._darkTheme.next(isDarkTheme);
  }

  get theme(){
    return this._theme;
  }

  get getBGSpinnerColor(){
    return this.theme ? 'rgb(' : 'warn';
  }

  getSpinnerTemplate(){
    return `<div class="ag-overlay-loading-center" role="presentation">
            <div
                role="presentation"
                style="width: 80px; height: 80px; background: url('./assets/image/temapi.gif') center / contain no-repeat; margin: 0 auto;"
            ></div>
            <div aria-live="polite" aria-atomic="true">${this.translate.instant('QUERY_EXECUTOR.AGGRID.LOADING')}</div>
        </div>`;
  }
}